import { useState, useEffect } from "react";

let _open = false;
const _listeners = new Set<() => void>();

function notify() {
  _listeners.forEach(l => l());
}

export function openDashboardModal() {
  _open = true;
  notify();
}

export function closeDashboardModal() {
  _open = false;
  notify();
}

export function useDashboardModal() {
  const [, tick] = useState(0);
  useEffect(() => {
    const update = () => tick(t => t + 1);
    _listeners.add(update);
    return () => { _listeners.delete(update); };
  }, []);
  return { isOpen: _open, close: closeDashboardModal };
}
